<template>
  <div class="app-container">
    <el-form
      ref="examineForm"
      :rules="examineRules"
      :model="examineForm"
      label-position="left"
      label-width="150px"
      style="width: 80%; margin-left:50px;"
    >
      <el-form-item label="姓名">
        <span>{{ examineObj.name }}</span>
      </el-form-item>

      <el-form-item label="性别">
        <span>{{ examineObj.gender }}</span>
      </el-form-item>
      <el-form-item label="出生日期">
        <span>{{ examineObj.birthday }}</span>
      </el-form-item>
      <el-form-item label="头像 ">
        <el-image
          style="width: 100px; height: 100px"
          :src="examineObj.avatarUrl"
          fit="cover"
        ></el-image>
      </el-form-item>
      <el-form-item label="邀请码">
        <span>{{ examineObj.inviteCode }}</span>
      </el-form-item>
      <el-form-item label="等级名称">
        <span>{{ examineObj.gradeName }}</span>
      </el-form-item>
      <el-form-item label="等级值">
        <span>{{ examineObj.gradeLevel }}</span>
      </el-form-item>
      <el-form-item label="手机号码">
        <span>{{ examineObj.mobile }}</span>
      </el-form-item>
      <el-form-item label="证件号码">
        <span>{{ examineObj.certNo }}</span>
      </el-form-item>

      <el-form-item label="证状证件类型">
        <span>{{ getValue(MEMBER_EXAMINE_TYPE, examineObj.certType) }}</span>
      </el-form-item>
      <el-form-item label="证件正面照片 ">
        <el-image
          style="width: 100px; height: 100px"
          :src="examineObj.certFimg"
          fit="cover"
          :preview-src-list="[examineObj.certFimg]"
        ></el-image>
      </el-form-item>
      <el-form-item label="证件背面照片 ">
        <el-image
          style="width: 100px; height: 100px"
          :src="examineObj.certBimg"
          fit="cover"
          :preview-src-list="[examineObj.certBimg]"
        ></el-image>
      </el-form-item>
      <el-form-item label="审核结果" prop="status">
        <el-select
          v-model="examineForm.status"
          placeholder="状态"
          style="width: 100%"
          class="filter-item"
          clearable
        >
          <el-option
            v-for="item in MEMBER_EXAMINE_STATUS"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer" style="text-align: center;">
      <el-button @click="jumpList">取消</el-button>
      <el-button type="primary" @click="examineOk">确定</el-button>
    </div>
  </div>
</template>

<script>
import { checkRealName, getMemberDetail } from "@/api/member";
import {
  getValue,
  MEMBER_EXAMINE_STATUS,
  MEMBER_EXAMINE_TYPE
} from "@/utils/enumUtile";
import { formatApiDate } from "@/utils/utils";

export default {
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    MEMBER_EXAMINE_STATUS() {
      return MEMBER_EXAMINE_STATUS;
    },
    MEMBER_EXAMINE_TYPE() {
      return MEMBER_EXAMINE_TYPE;
    }
  },
  name: "examine",
  data() {
    return {
      examineObj: {}, // 审核的弹框
      examineRules: {
        status: [
          { required: true, message: "审核结果不能为空", trigger: "change" }
        ]
      },
      examineForm: {
        id: 0, //
        status: null
      }
    };
  },
  mounted() {
    const id = this.$route.params.id;
    if (id && id !== 0) {
      this.examineForm.id = id;
      this.getById(id);
    }
  },
  methods: {
    getValue,
    async getById(id) {
      const params = {
        id
      };
      const resp = await getMemberDetail(params);
      if (resp && resp.bizcode) {
        this.examineObj = resp.data;
      }
    },
    /**
     * 返回列表
     */
    jumpList() {
      this.$confirm("当前编辑的内容未保存，是否立即返回会员列表？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$router.push({ path: `/member/list?isDetailPage=${true}` });
      });
    },
    // 审核 start
    checkExamineVisible(val, obj = {}) {
      this.examineObj = obj;
      if (obj && Object.keys(obj).length !== 0) {
        this.examineForm.id = obj.id;
      }
      this.examineVisible = val;
    },
    examineOk() {
      this.$refs["examineForm"].validate(valid => {
        if (valid) {
          const form = this.examineForm;
          const params = {
            ...form
          };
          checkRealName(params).then(() => {
            this.checkExamineVisible(false);
            this.$notify({
              title: "成功",
              message: "审核成功",
              type: "success",
              duration: 2000
            });
            setTimeout(() => {
              this.$router.push({ path: `/member/list?isDetailPage=${true}` });
            }, 2000);
          });
        }
      });
    }
    // 审核 end
  }
};
</script>

<style scoped></style>
